import React from "react";
import {
  QueryTPMSData,
  QueryTPMSConfig,
  QueryTPMSReceiverState,
  QueryMostRecentFrames,
  SubscribeTPMSConfig,
  SubscribeTPMSBatchFrames,
  SubscribeTPMSReceiverState,
  MutateTPMSConfig,
  QueryUsingAKSWeather,
  SubscribeUsingAKSWeatherUpdate,
} from "../../../utils/graphql/hooks/TPMSHooks";

export default function TPMSDataManager() {
  QueryUsingAKSWeather();
  SubscribeUsingAKSWeatherUpdate();
  QueryTPMSConfig();
  QueryTPMSData();
  QueryMostRecentFrames();
  QueryTPMSReceiverState();
  SubscribeTPMSReceiverState();
  SubscribeTPMSConfig();
  SubscribeTPMSBatchFrames();
  MutateTPMSConfig();
  return <></>;
}
